<div role="group" class="example-tel-input-container" [formGroup]="formGroup">
    <mat-select
        #select
        panelClass="custom-tree-select-overlay"
        (selectionChange)="onSelectionChange($event)"
        [value]="value"
    >
        <mat-select-trigger>
            {{ formGroup.value.option.description }}
        </mat-select-trigger>
        <app-tree-view [data]="options" [nodeTemplateRef]="nodeTemplate" [isCompactMode]="true">
        </app-tree-view>
        <ng-template #nodeTemplate let-node="data">
            <mat-option class="option" [value]="node.item">
                <mat-icon *ngIf="node.item.icon" class="icon">{{ node.item.icon }}</mat-icon>
                <span>{{ node.item.label }}</span>
            </mat-option>
        </ng-template>
    </mat-select>
</div>
